import React, { Fragment } from "react";
import moment from "moment";
import Tooltip from "@material-ui/core/Tooltip";
import Loading from "../../components/Loading/Loading";
import HeaderComponent from "../../components/Header";
import notfound from "../../static/images/notfound.png";
import allowcamera from "../../static/images/allowcamera.png";
import feedbackImage from "../../static/images/feedback.svg";
import downIcon from "../../static/images/down-icon.svg";
import {
  slotActions,
  appointmentActions,
  sessionActions,
  authActions,
  alertActions,
  counsellorActions,
} from "../../store/actions";
import { languagesArray } from "../../config";
import { connect } from "react-redux";
import image1 from "../../static/images/1.svg";
import image2 from "../../static/images/2.svg";
import image3 from "../../static/images/3new.svg";
import image4 from "../../static/images/3.svg";
import image5 from "../../static/images/carbon_blog.svg";
import Footer from "../../components/Footer/footer";
import Swal from "sweetalert2";
import { ANALYTICS_EVENTS, constants } from "../../Constants";
import { getSubDomain, history } from "../../helpers";
import "../../static/css/styles.css";
import { counsellorDahsCont, patientDashboard } from "../../helpers/ConstantID";
import FeedbackModal from "../../components/Feedback/feedback";
import { ServiceTypeModal } from "../../components/ServiceTypeModal";
import { serviceTypeActions } from "../../store/actions/serviceType.actions";
import { error } from "jquery";
import { pushToDataLayer } from "../../helpers/analytics";

const styles = {
  customWidth: {
    maxWidth: 500,
  },
  noMaxWidth: {
    maxWidth: "none",
  },
};

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownValue: "0",
      selectedDate: "",
      normalState: true,
      searchedState: false,
      slot_id: "",
      session: [],
      searchedTimeSlots: [],
      counsellor_id: "",
      role: sessionStorage.getItem("role"),
      appointments: [],
      appointmentsChanged: false,
      allowedPermissions: false,
      resourceError: "",
      joinDisable: false,
      showFeedback: false,
      language: "",
      languageFlag: "",
      relation_with: [],
      langSelected: '',
      languagesView: false,
      languageListTrigger: false,
      languageError: '',
      showServiceTypeModal: false,

    };
    this.textInput = React.createRef();
    this.JoinSession = this.JoinSession.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.deleteTimeSlot = this.deleteTimeSlot.bind(this);
    this.checkPermissions = this.checkPermissions.bind(this);
    this.handleLangChange = this.handleLangChange.bind(this);
  }

  componentWillMount() {
    const project_id = localStorage.getItem("project_id");
    const subDomain = getSubDomain();
    this.props.getUserData();
    this.props.getAppointments(project_id);
    if (this.props.user && this.props.user !== undefined) {
      if (this.props.user.role === 0) {
        history.replace("/home/counsellor");
      }
      else if (subDomain){
        pushToDataLayer(ANALYTICS_EVENTS.PAGE_VISITS.HOME_PAGE, {
          sub_domain: subDomain,
        });
      }
    }
  }

  componentDidMount() {
    if (localStorage.getItem("session_ended")) {
      localStorage.removeItem("session_ended");
      window.location.reload(true);
    }
    this.browserDetcet();
    this.props.getMultiCounsellor()
    this.props.fetchServiceType();

  }
  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.user && nextProps.multiCounsellor && nextProps.multiCounsellor.error) {
      if (
        nextProps.whitelabel &&
        nextProps.whitelabel[0].name.toLowerCase() !== "cwp"
      ) history.push("/counsellor-list")
    } else if (nextProps.multiCounsellor) {
      this.setState({ relation_with: nextProps.multiCounsellor })
    }
    const project_id = localStorage.getItem("project_id");

    if (this.state.appointmentsChanged) {
      this.props.getAppointments(project_id);
    }
    this.setState({
      appointments: nextProps.appointments,
      appointmentsChanged: false,
    });
  }

  createAppointmentPage = (clickedServiceType) => {
    let counsellor_id;
    if (this.state.relation_with.length > 0) {
      this.state.relation_with.forEach(relation => {
        if (relation.service_type.code === clickedServiceType) {
          counsellor_id = relation.id
        }
      })
      let serviceTypes = this.props.serviceTypes
      let serviceTypeFoundForProject = serviceTypes.service_types.some((item1) => {
        let isFound = this.props.user.projects[0].project_service_types.some(
          (item2) => item2.service_type.code.toLowerCase() === clickedServiceType.toLowerCase()
        )
        return isFound
      })

      
      if (counsellor_id) {
        history.push(`/create_appointment/${counsellor_id}`);
      } else if (!serviceTypeFoundForProject) {
        Swal.fire({
          titleText: constants.SUBSCRIPTION_TXT,
          html: constants.SERVICE_NOT_SUBSCRIBED_MESSAGE(clickedServiceType).replace(
            'contact@saayahealth.com', 
            '<a href="mailto:contact@saayahealth.com">contact@saayahealth.com</a>'
          ),
        }); 
      } else {
        localStorage.setItem("selected_type", clickedServiceType)
        localStorage.setItem('language', this.state.langSelected)
        history.push("/counsellor-list");
      }
    }

    if (this.props.whitelabel && this.props.whitelabel[0].name.toLowerCase() === "cwp" && this.state.langSelected === '') {
      this.setState({ languageError: constants.LANGUAGES_ERROR_TXT })
      return;
    } else if (this.props.whitelabel && this.props.whitelabel[0].name.toLowerCase() === "cwp" && this.state.relation_with.length === 0) {
      history.push("/counsellor-list");
    }
  };

  redirectFaq = () => {
    const subDomain = getSubDomain();
    if (subDomain) {
      pushToDataLayer(ANALYTICS_EVENTS.BUTTON_CLICKS.FAQ_BTN, {
        sub_domain: subDomain,
      });
    }
    history.push(`/faq`);
  };

  redirectBlogs = () => {
    const subDomain = getSubDomain();
    if (subDomain) {
      pushToDataLayer(ANALYTICS_EVENTS.BUTTON_CLICKS.VIEW_BLOGS_BTN, {
        sub_domain: subDomain,
      });
    }
    window.open(`https://saayahealth.com/blog`);
  };

  handleObject = (e) => { };

  componentWillUnmount() {
    this.props.clearAlertActions();
  }
  handleLangChange = (elem) => {
    this.setState({ language: elem.key, languageFlag: elem.image, langSelected: elem.value, languageError: '' });
  };

  modalHandler = (isOpen) => {
    
    const { whitelabel } = this.props
    if (isOpen) {
      const subDomain = getSubDomain();
      if (subDomain) {
        pushToDataLayer(ANALYTICS_EVENTS.BUTTON_CLICKS.SCHEDULE_SESSION_BTN, {
          sub_domain: subDomain,
        });
      }
    }
    if (whitelabel && whitelabel[0].name.toLowerCase() === 'cwp') {
      this.createAppointmentPage("wellbeing")
    } else
      if (this.props.serviceTypes.service_types.error) {
        Swal.fire({
          icon: 'error',
          text: this.props.serviceTypes.service_types.error
        })
      } else {
        this.setState({
          showServiceTypeModal: isOpen,
        });
      }
  }

  sessionDetailsHandler(sessionID) {
    history.push(`/appointment-details/${sessionID}`)
  }

  handleChange(e) {
    const apointmentID = e;
    const filterAppointments = this.state.appointments.filter(function (obj) {
      return obj.id !== apointmentID;
    });

    Swal.fire({
      title: "Are you sure?",
      text: "You want to Cancel your appointment!",
      type: "warning",
      reverseButtons: true,
      showCancelButton: true,
      confirmButtonColor: "#36A692",
      cancelButtonColor: "#d33",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.value) {
        this.props.cancelAppointment(apointmentID);
        this.setState({
          appointments: filterAppointments,
          appointmentsChanged: true,
        });

        Swal.fire(
          "Saaya Health",
          "Your Appointment has been cancelled!",
          "success"
        );
      } else {
      }
    });
  }

  openNotes = () => {
    const subDomain = getSubDomain();
    if (subDomain) {
      pushToDataLayer(ANALYTICS_EVENTS.BUTTON_CLICKS.OPEN_NOTE_BTN, {
        sub_domain: subDomain,
      });
    }
    history.push("/note");
  };
  redirectTaskeen = () => {
    const { whitelabel } = this.props
    const subDomain = getSubDomain();
    if (subDomain) {
      pushToDataLayer(ANALYTICS_EVENTS.BUTTON_CLICKS.LEARN_ABOUT_WELLBEING_BTN, {
        sub_domain: subDomain,
      });
    }
    
      Swal.fire({
        title: "You will now be redirected!",
        text: `You will now be redirected to our ${whitelabel && whitelabel[0].name.toLowerCase() === "cwp" ? 'Wellness portal' : 'Saaya Blog'} where you can find more information about your wellbeing!`,
        type: "warning",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: "#36A692",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          whitelabel && whitelabel[0].name.toLowerCase() === "cwp" ?
          window.open(`${"https://wellness.saayahealth.com/"}`):
          window.open(`${"https://www.saayahealth.com/blog"}`);
        }
      });
  };

  toggleButtonStatus = (date_time) => { };

  /* Check Browser and OS */
  browserDetcet = () => {
    const BrowserDetect = {
      init: function () {
        this.browser =
          this.searchString(this.dataBrowser) || "An unknown browser";
        this.version =
          this.searchVersion(navigator.userAgent) ||
          this.searchVersion(navigator.appVersion) ||
          "an unknown version";
        this.OS = this.searchString(this.dataOS) || "an unknown OS";
      },
      searchString: function (data) {
        for (var i = 0; i < data.length; i++) {
          var dataString = data[i].string;
          var dataProp = data[i].prop;
          this.versionSearchString = data[i].versionSearch || data[i].identity;
          if (dataString) {
            if (dataString.indexOf(data[i].subString) != -1)
              return data[i].identity;
          } else if (dataProp) return data[i].identity;
        }
      },
      searchVersion: function (dataString) {
        var index = dataString.indexOf(this.versionSearchString);
        if (index == -1) return;
        return parseFloat(
          dataString.substring(index + this.versionSearchString.length + 1)
        );
      },
      dataBrowser: [
        {
          string: navigator.userAgent,
          subString: "Chrome",
          identity: "Chrome",
        },
        {
          string: navigator.userAgent,
          subString: "OmniWeb",
          versionSearch: "OmniWeb/",
          identity: "OmniWeb",
        },
        {
          string: navigator.vendor,
          subString: "Apple",
          identity: "Safari",
          versionSearch: "Version",
        },
        {
          prop: window.opera,
          identity: "Opera",
          versionSearch: "Version",
        },
        {
          string: navigator.vendor,
          subString: "iCab",
          identity: "iCab",
        },
        {
          string: navigator.vendor,
          subString: "KDE",
          identity: "Konqueror",
        },
        {
          string: navigator.userAgent,
          subString: "Firefox",
          identity: "Firefox",
        },
        {
          string: navigator.vendor,
          subString: "Camino",
          identity: "Camino",
        },
        {
          // for newer Netscapes (6+)
          string: navigator.userAgent,
          subString: "Netscape",
          identity: "Netscape",
        },
        {
          string: navigator.userAgent,
          subString: "MSIE",
          identity: "Explorer",
          versionSearch: "MSIE",
        },
        {
          string: navigator.userAgent,
          subString: "Gecko",
          identity: "Mozilla",
          versionSearch: "rv",
        },
        {
          // for older Netscapes (4-)
          string: navigator.userAgent,
          subString: "Mozilla",
          identity: "Netscape",
          versionSearch: "Mozilla",
        },
      ],
      dataOS: [
        {
          string: navigator.platform,
          subString: "Win",
          identity: "Windows",
        },
        {
          string: navigator.platform,
          subString: "Mac",
          identity: "Mac",
        },
        {
          string: navigator.userAgent,
          subString: "iPhone",
          identity: "IOS",
        },
        {
          string: navigator.platform,
          subString: "iPad",
          identity: "IOS",
        },
        {
          string: navigator.platform,
          subString: "Linux",
          identity: "Linux",
        },
      ],
    };

    BrowserDetect.init();

    var isMobile = {
      Android: function () {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
      },
      any: function () {
        return (
          isMobile.Android() ||
          isMobile.BlackBerry() ||
          isMobile.iOS() ||
          isMobile.Opera() ||
          isMobile.Windows()
        );
      },
    };

    const os = BrowserDetect.OS;
    const browser = BrowserDetect.browser + BrowserDetect.version;

    this.setState({
      os,
    });
    this.setState({
      browser,
    });
    if (isMobile.any() == null || undefined) {
      let device = "PC";
      this.setState({
        device: "PC",
      });
    } else {
      let device = isMobile.any();
      this.setState({
        device: device[0],
      });
    }
  };
  /* Check Browser and OS */
  checkPermissions = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: true,
      });
      /* use the stream */
      this.setState({ allowedPermissions: true });
      return { success: true, msg: "" };
    } catch (err) {
      this.setState({ allowedPermissions: false, resourceError: err });
      return { success: false, msg: err };
    }
  };

  redirectHome = () => {
    history.replace("/home");
  };

  JoinSession(appointment_id, schedule) {
    if (!moment(schedule).isBefore(moment().add("10", "m"))) return false;

    // add preventdefault here to avoid multipe hits possibility
    if (this.state.joinDisable) {
      return;
    }
    this.setState({ joinDisable: true });
    this.btn.setAttribute("disabled", "disabled");

    this.checkPermissions().then((response) => {
      let msg = "";
      if (!response.success) {
        if (
          response.msg.toString().indexOf("Could not start video source") > -1
        )
          msg = constants.REOURCE_IN_USE_ERROR;
        else if (response.msg.toString().indexOf("device not found") > -1)
          msg = constants.RESEOURCE_NOT_FOUND_ERROR;
        else if (
          response.msg.toString().indexOf("Permission denied") > -1 ||
          response.msg.toString().indexOf("NotAllowedError") > -1 ||
          response.msg.toString().indexOf("The object can not be found here") >
          -1
        )
          msg = constants.UNSUPPORTED_MSG_BODY;

        Swal.fire({
          title: constants.UNSUPPORTED_MSG_TITLE,
          text: msg !== "" ? msg : constants.SESSION_GENERAL_ERROR,
          //onClose: this.redirectHome()
        });
        this.setState({ joinDisable: false });
        return false;
      } else {
        const appointmentId = appointment_id;
        const OT = window.OT.checkSystemRequirements();
        const os = this.state.os;
        const browser = this.state.browser;
        const device = this.state.device;

        if (OT === 0) {
          Swal.fire({
            title: "Please update your browser!",
            text: "Please update your browser.Your browser version is old which can cause problem..",
            confirmButtonColor: "#36A692",

            imageUrl:
              "https://publicize.co/wp-content/uploads/2017/08/dfghj.jpg",
            imageWidth: 300,
            imageHeight: 200,
            imageAlt: "camera not found",
          });
        }

        const { appointments, openTokService } = this.props;
        
        openTokService(appointmentId, os, browser, device);

        const appointmentDetails = appointments && appointments.find(app => app.id === appointmentId);
        if (appointmentDetails) {
          const { patient_name, counsellor_name,date_time } = appointmentDetails;
          localStorage.setItem('appointmentDetails', JSON.stringify({ patient_name, counsellor_name,date_time }));
        }

        function videoError(e) {
          const error = e.toString();
          if (error.includes("NotFoundError") === true) {
            Swal.fire({
              title: "Camera Or Microphone Not Found!",
              text: "Please connect a camera and microphone and try again to join session.",
              confirmButtonColor: "#36A692",

              imageUrl: notfound,
              imageWidth: 500,
              imageHeight: 250,
              imageAlt: "camera not found",
            });
          }

          if (error.includes("Invalid constraint") === true) {
            Swal.fire({
              title: "Camera Not Found!",
              text: "Please connect a camera and try again to join sessions.",
              confirmButtonColor: "#36A692",

              imageUrl: notfound,
              imageWidth: 500,
              imageHeight: 250,
              imageAlt: "camera not found",
            });
          }

          if (error.includes("NotAllowedError") === true) {
            Swal.fire({
              title: "You have blocked camera and Microphone!",
              confirmButtonColor: "#36A692",

              text: "Please Follow above instruction to enable camera and microphone and then you can try again to join session.",
              imageUrl: allowcamera,
              imageWidth: 400,
              imageHeight: 300,
              imageAlt: "camera and Microphone blocked",
            });
          }
          this.setState({ joinDisable: false });
        }
      }
    });
    this.btn.removeAttribute("disabled");
    // this.setState({joinDisable : false})
  }

  deleteTimeSlot(e) {
    const { dispatch } = this.props;
    dispatch(slotActions.deleteTimeSlot(e.target.value));
  }

  technicalFeedback = () => {
    if (!this.state.showFeedback) {
      const subDomain = getSubDomain();
      if (subDomain) {
        pushToDataLayer(ANALYTICS_EVENTS.BUTTON_CLICKS.FEEDBACK_BTN, {
          sub_domain: subDomain,
        });
      }
    }
    this.setState({ showFeedback: !this.state.showFeedback });
  };

  openUrl = () => {
    window.open(constants.PATIENT_FEEDBACK_URL, "_blank");
    this.setState({ showFeedback: false });
  };

  render() {
    const { user, whitelabel, appointments } = this.props;
    const dateObj = new Date();
    if (this.props.appointments !== undefined) {
      return (
        <div className="sh-layout" onClick={() => {
          this.state.languageListTrigger && this.setState({
            languageListTrigger: !this.state.languageListTrigger,
          });
        }}>
          <HeaderComponent />

          <div className="sh-patient-dash-comp sh-gnrl-width">
            {/* Welcome Note */}
            <div className="sh-gnrl-welcome-note">
              <h2
                className="sh-gnrl-welcome"
                id={patientDashboard.sh_pd_patient_name}
              >
                WELCOME {user && user.full_name && user.full_name.toUpperCase()}
              </h2>
            </div>
            {whitelabel && whitelabel[0].name.toLowerCase() === "cwp" && (
              <React.Fragment>
                <div className="text-align-center mb10 chooseLang">
                  Choose your language
                </div>
                <div className="text-align-center mb10">
                  <div
                    class="dropdown"
                    onClick={() => {
                      this.setState({
                        languageListTrigger: !this.state.languageListTrigger,
                      });
                    }}
                  >
                    <button class="dropbtn">
                      {this.state.language ? (
                        <Fragment>
                          <img
                            width="20px"
                            style={{
                              textAlign: "left",
                              verticalAlign: "unset",
                            }}
                            height="15px"
                            src={this.state.languageFlag}
                            alt=""
                          />{" "}
                          <span>{this.state.language}</span>
                          <img
                            width="20px"
                            style={{
                              textAlign: "right",
                              verticalAlign: "unset",
                              right: '10px', position: 'absolute',
                              paddingTop: '5px'
                            }}
                            height="15px"
                            src={downIcon}
                            alt=""
                          />
                        </Fragment>
                      ) : (
                        <Fragment>
                          <span style={{ color: "#565656" }}>{constants.SELECT_LANGUAGE_TXT}</span>
                          <img
                            width="20px"
                            style={{
                              textAlign: "right",
                              verticalAlign: "unset",
                              right: '10px', position: 'absolute',
                              paddingTop: '5px'
                            }}
                            height="15px"
                            src={downIcon}
                            alt=""
                          />
                        </Fragment>
                      )}
                    </button>

                    <div
                      class="dropdown-content"
                      style={{
                        display: this.state.languageListTrigger
                          ? "block"
                          : "none",
                      }}
                      onBlur={() => {
                        this.setState({
                          languageListTrigger: !this.state.languageListTrigger,
                        });
                      }}

                    >
                      {languagesArray &&
                        languagesArray.map((lang) => (
                          <a

                            href={(e) => {
                              return false;
                            }}
                            onClick={() => this.handleLangChange(lang)}
                          >
                            <img
                              src={lang.image}
                              alt=""
                              width="20px"
                              height="15px"
                            />{" "}
                            {lang.key}
                          </a>
                        ))}
                    </div>
                  </div>
                </div>
              </React.Fragment>
            )}

            {this.state.languageError !== '' &&
              <div className="sh-error-text" id="errorMessage">
                {this.state.languageError}
              </div>
            }
            {/* Session Div */}
            <div className="sh-gnrl-container">
              <div className="sh-gnrl-cont-header">
                <h3 className="sh-gnrl-ch-heading">
                  {constants.YOUR_NEXT_SESSION_TXT}
                </h3>
              </div>
              {appointments &&
                appointments.length > 0 &&
                this.state.appointments.filter((app) => {
                  if (moment(app.date_time).add("60", "m").isAfter(moment())) {
                    return true;
                  }
                }).length > 0 ? (
                <div className="sh-gnrl-cont-content">
                  {/* Header for counsellor */}
                  <div className="sh-gnrl-cc-row">
                    <div className="sh-gnrl-col-1 sh-mble-col-1">
                      <span className="sh-gnrl-cchc-main-head">
                        {whitelabel && whitelabel[0]
                          ? whitelabel[0].producer_role
                          : constants.COUNSELLOR}
                      </span>
                    </div>
                    <div className="sh-gnrl-col-2 sh-mble-col-3">
                      <span className="sh-gnrl-cchc-main-head">
                        {constants.WHEN_TXT}
                      </span>
                    </div>
                    <div className="sh-gnrl-col-1 sh-mble-col-1">
                      <span className="sh-gnrl-cchc-main-head">
                        <i className="fa fa-bars"></i>
                      </span>
                    </div>
                  </div>

                  {this.props.appointments &&
                    this.state.appointments
                      .filter((app) => {
                        if (
                          moment(app.date_time).add("60", "m").isAfter(moment())
                        ) {
                          return true;
                        }
                      })
                      .map((v, i) => {
                        return (
                          <div className="sh-gnrl-cc-row">
                            <div className="sh-gnrl-col-1 sh-mble-col-1">
                              <span
                                className="sh-gnrl-cchc-main-title"
                                id={`${counsellorDahsCont.sh_cl_app_name}${i}`}
                              >
                                {v.counsellor_name}
                              </span>
                            </div>
                            <div className="sh-gnrl-col-2 sh-mble-col-3">
                              <span
                                className="sh-gnrl-cchc-main-title"
                                id={`${counsellorDahsCont.sh_cl_app_time}${i}`}
                              >
                                {moment(v.date_time)
                                  .format("ddd DD MMM YYYY hh:mm:ss A")
                                  .toLocaleString("en-US", {
                                    hour: "numeric",
                                    hour12: true,
                                  })}
                              </span>
                            </div>

                            <div className="sh-gnrl-col-1 sh-mble-col-unset">
                              {moment(v.date_time).isBefore(
                                moment().add("24", "h")
                              ) ? (
                                <Tooltip
                                  title={
                                    moment(v.date_time).isBefore(
                                      moment().add("10", "m")
                                    )
                                      ? ""
                                      : `You will be able to join this session 10 minutes before the start time. Current time of your device is ${moment(
                                        new Date()
                                      ).toString()}. If you wish to change or cancel the session please email us at contact@saayahealth.com`
                                  }
                                  disableFocusListener
                                  disableTouchListener
                                  classes={{ tooltip: styles.customWidth }}
                                >
                                  <button
                                    className="sh-btn-join sh-gnrl-btn-session"
                                    onClick={() =>
                                      this.JoinSession(v.id, v.date_time)
                                    }
                                    ref={(btn) => {
                                      this.btn = btn;
                                    }}
                                    disabled={this.state.joinDisable}
                                    id={patientDashboard.sh_pd_join_btn}
                                  >
                                    <span className="sh-text-icon">
                                      {constants.JOIN_TXT}
                                    </span>
                                    <span className="icon"></span>
                                  </button>
                                </Tooltip>
                              ) : (
                                <button
                                  className="sh-btn-cancel sh-gnrl-btn-session "
                                  id={patientDashboard.sh_pd_cancel_btn}
                                  value={v.id}
                                  onClick={() => this.handleChange(v.id)}
                                >
                                  <span className="sh-text-icon">
                                    {constants.CANCEL_TXT}
                                  </span>
                                  <span className="icon"></span>
                                </button>
                              )}
                              <button
                                className="sh-btn-detail sh-gnrl-btn-session "
                                id={patientDashboard.sh_pd_detail_btn}
                                value={v.id}
                                onClick={() => this.sessionDetailsHandler(v.id)}
                              >
                                <span className="sh-text-icon">
                                  {constants.DETAILS_TXT}
                                </span>
                                <span className="icon"></span>
                              </button>
                            </div>
                          </div>
                        );
                      })}
                  {/* Main content Counsellor */}
                </div>
              ) : (
                <div className="sh-gnrl-cont-content">
                  <div className="sh-gnrl-cc-row">
                    <div className="sh-gnrl-col-1">
                      <span className="sh-gnrl-cchc-main-title">
                        {constants.NO_APPOINTMENTS_TXT}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* Mian Dashboard */}
            <div className="sh-main-dash-container">
              <div className="sh-mdc-col-1">
                <div
                  className="sh-mdc-inner"
                  id={patientDashboard.sh_pd_schedule_session}
                  onClick={() => this.modalHandler(true)}
                >
                  <div className="sh-mdc-image">
                    <img src={image1} alt="scheduling icon" />
                  </div>
                  <div className="sh-mdc-text">
                    <span>{constants.SCHEDULE_SESSION_TEXT}</span>
                  </div>
                </div>
              </div>

              <div className="sh-mdc-col-1">
                <div
                  className="sh-mdc-inner"
                  id={patientDashboard.sh_pd_your_notes}
                  onClick={this.openNotes}
                >
                  <div className="sh-mdc-image">
                    <img src={image2} id="imgNotes" />
                  </div>
                  <div className="sh-mdc-text">
                    <span>{constants.NOTES_TEXT}</span>
                  </div>
                </div>
              </div>

              <div className="sh-mdc-col-1">
                <div
                  className="sh-mdc-inner"
                  id={patientDashboard.sh_pd_faq}
                  onClick={this.redirectFaq}
                >
                  <div className="sh-mdc-image">
                    <img src={image4} alt="wellbeing icon" />
                  </div>
                  <div className="sh-mdc-text">
                    <span>{constants.FAQ_TEXT}</span>
                  </div>
                </div>
              </div>

              <div className="sh-mdc-col-1">
                <div className="sh-mdc-inner" onClick={this.technicalFeedback}>
                  <div className="sh-mdc-image">
                    <img src={feedbackImage} alt="feedback icon" />
                  </div>
                  <div className="sh-mdc-text">
                    <span>Feedback</span>
                  </div>
                </div>
              </div>

              <div className="sh-mdc-col-1 mt-20">
                <div
                  className="sh-mdc-inner"
                  id={patientDashboard.sh_pd_learn_about_wellbeing}
                  onClick={this.redirectTaskeen}
                >
                  <div className="sh-mdc-image">
                    <img src={image3} alt="faq icon" />
                  </div>
                  <div className="sh-mdc-text">
                    <span>Learn about wellbeing</span>
                  </div>
                </div>
              </div>

              <div className="sh-mdc-col-1 mt-20">
                <div
                  className="sh-mdc-inner"
                  id={patientDashboard.sh_pd_schedule_session}
                  onClick={this.redirectBlogs}
                >
                  <div className="sh-mdc-image">
                    <img src={image5} alt="blog_icons" />
                  </div>
                  <div className="sh-mdc-text">
                    <span>{constants.VIEW_BLOGS_TXT}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.state.showServiceTypeModal &&
            <ServiceTypeModal
              serviceTypes={this.props.serviceTypes}
              closeModal={() => this.modalHandler(false)}
              handleAppointmentPage={this.createAppointmentPage}
            />
          }
          {this.state.showFeedback ? (
            <FeedbackModal
              feedbackModal={this.technicalFeedback}
              openUrl={this.openUrl}
              FEEDBACK_HEADING={constants.PATIENT_FEEDBACK_HEADING}
              FEEDBACK_TEXT={constants.PATIENT_FEEDBACK_TEXT}
              FEEDBACK_BTN_TEXT={constants.PATIENT_FEEDBACK_BTN_TEXT}
            />
          ) : (
            ""
          )}

          <Footer />
        </div>
      );
    } else {
      return <Loading />;
    }
  }
}

function mapStateToProps(state) {
  const { session, auth, alert, counsellorStatus, serviceTypes } = state;
  const { appointments } = state.appointments;
  const { user } = auth;
  const { whitelabel } = state.whitelabel;
  return {
    user,
    alert,
    appointments,
    session,
    whitelabel,
    serviceTypes,
    multiCounsellor: counsellorStatus.multiCounsellor
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getAppointments: (id) => {
      dispatch(appointmentActions.getAppointments(id));
    },
    getUserData: () => {
      dispatch(authActions.getUserData());
    },
    cancelAppointment: (value) => {
      dispatch(appointmentActions.cancelAppointment(value));
    },
    clearAlertActions: () => {
      dispatch(alertActions.clear());
    },
    openTokService: (appointmentId, os, browser, device) => {
      dispatch(
        sessionActions.OpenTokService(appointmentId, os, browser, device)
      );
    },
    fetchServiceType: () => {
      dispatch(serviceTypeActions.fetchServiceType());
    },
    getMultiCounsellor: () => {
      dispatch(
        counsellorActions.getMultiCounsellor()
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/screens/Home/index.js